export default "__VITE_ASSET__BkoTzTr6__"